import {
  SImage,
  SImageWrapper,
  SSubtitle,
  STextWrapper,
  STitle,
  SWrapper,
} from './SongListItem.styled'
import { Song } from 'components/content/singingPortraits/chooseSongModal/types'
import { Icon } from 'components/icon'
import { useRef, useState } from 'react'
import { colors } from 'utils/colors'

export function SongListItem(props: {
  selected: boolean
  onSelect: () => void
  songData: Song | null
}) {
  const audioRef = useRef<HTMLAudioElement>(null)

  const [audioStatus, setAudioStatus] = useState<'playing' | 'paused' | 'none'>('none')

  const onClick = () => {
    props.onSelect()

    if (audioRef.current) {
      if (audioStatus === 'playing') audioRef.current?.pause()
      else audioRef.current?.play()
    }
  }

  const isPlaying = props.selected && audioStatus === 'playing'
  const isPaused = props.selected && audioStatus === 'paused'

  return (
    <SWrapper type="button" variant="secondary" size="large" block onClick={onClick}>
      {props.selected && (
        <audio
          ref={audioRef}
          src={props.songData?.song?.url || ''}
          autoPlay
          onPlay={() => setAudioStatus('playing')}
          onPause={() => setAudioStatus('paused')}
          onEnded={() => setAudioStatus('none')}
        />
      )}
      <SImageWrapper>
        <SImage src={props.songData?.image?.url as string} />
        {isPlaying && <Icon name="Pause" color="white" />}
        {isPaused && <Icon name="Play" color="white" />}
      </SImageWrapper>
      <STextWrapper>
        <STitle>{props.songData?.songName}</STitle>
        <SSubtitle>{props.songData?.artist}</SSubtitle>
      </STextWrapper>

      {props.selected && <Icon name="Check" color={colors.green[200]} />}
    </SWrapper>
  )
}
